import React from 'react';
import { CloseIcon } from '../icons';
import classes from './CloseButton.module.scss';

const CloseButton = ({ onClick, ariaLabel = 'Close', customClass }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    className={classes.Button + (customClass ? ' ' + customClass : '')}
  >
    <CloseIcon customClass={classes.Icon} />
  </button>
);

export default React.memo(CloseButton);
